/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { default as Tile } from "./Tile";
export type { TileProps } from "./TileProps";
export {
  getTileDimensions,
  TILE_DIMENSION_MAP,
  DEFAULT_TILE_DIMENSIONS,
  CarouselTemplateMapper
} from "../../../viewModel/utility/CarouselTemplateUtil";
export type { TTileDimensions } from "../../../viewModel/utility/CarouselTemplateUtil";
